// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import { useRef } from 'react';
import { UserMenu } from '../UserMenu';

interface RoomActionBarProps {
  roomCount: number;
  isPulsing: boolean;
  onRefresh: () => void;
}

export function RoomActionBar({ roomCount, isPulsing, onRefresh }: RoomActionBarProps) {
  const sessionIndicatorRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="glass border-b border-white/20 py-3 relative z-[60]">
      <div className="container mx-auto max-w-6xl px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h1
            className="font-display text-2xl font-bold"
            style={{ color: 'var(--color-primary)' }}
            data-testid="home-title"
          >
            UNDEF ENGINE
          </h1>
        </div>
        <div className="flex items-center gap-3">
          <button
            ref={sessionIndicatorRef}
            onClick={onRefresh}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors bg-white/10 hover:bg-white/20 ${isPulsing ? 'pulse-highlight' : ''}`}
            title="Click to refresh"
            data-testid="home-active-rooms-count"
          >
            {roomCount} room{roomCount !== 1 ? 's' : ''} active
          </button>
          <UserMenu />
        </div>
      </div>
    </div>
  );
}
